/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Event_Group_Sync_Error_ToastInputs */



/**
* | output |
* | --- |
* | "There was an error syncing changes. {error}" |
*
* @param {Event_Group_Sync_Error_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_error_toast = /** @type {((inputs: Event_Group_Sync_Error_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Error_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
	return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
});